export const SET_USER = 'SET_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SET_IMPERSONATED_USER = 'SET_IMPERSONATED_USER';
